// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddSeries_container__OzAyl {
    min-height: 100vh;
    padding: 2.5rem;
    background-color: #000000;
  }
  
  .AddSeries_form__3BE1y {
    max-width: 800px;
    margin: 0 auto;
    padding: 2.5rem;
    background-color: #121212;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
  }
  
  .AddSeries_title__yYStD {
    color: #D32F2F;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    position: relative;
    padding-bottom: 0.75rem;
  }
  
  .AddSeries_title__yYStD::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #D32F2F;
    border-radius: 3px;
  }
  
  .AddSeries_imageUpload__gRAIr {
    width: 100%;
    min-height: 240px;
    border: 2px dashed #333333;
    border-radius: 12px;
    background-color: #1A1A1A;
    transition: all 0.3s ease;
  }
  
  .AddSeries_imageUpload__gRAIr:hover {
    border-color: #D32F2F;
    background-color: #1E1E1E;
  }
  
  .AddSeries_uploadPlaceholder__ZAp1r {
    position: relative;
    width: 100%;
    height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #888888;
    gap: 1rem;
  }
  
  .AddSeries_uploadPlaceholder__ZAp1r::before {
    content: '📸';
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
  
  .AddSeries_fileInput__oPgXk {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .AddSeries_previewContainer__d8HVW {
    position: relative;
    width: 100%;
    height: 240px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #1A1A1A;
  }
  
  .AddSeries_preview__Ey57H {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .AddSeries_previewContainer__d8HVW:hover .AddSeries_preview__Ey57H {
    transform: scale(1.02);
  }
  
  .AddSeries_removeButton__\\+nv\\+y {
    position: absolute;
    top: 12px;
    right: 12px;
    background-color: #D32F2F;
    color: white;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  
  .AddSeries_removeButton__\\+nv\\+y:hover {
    background-color: #B71C1C;
    transform: scale(1.05);
  }
  
  .AddSeries_inputGroup__T20pa {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .AddSeries_inputGroup__T20pa label {
    color: #FFFFFF;
    font-weight: 500;
    font-size: 0.95rem;
  }
  
  .AddSeries_inputGroup__T20pa input,
  .AddSeries_inputGroup__T20pa textarea,
  .AddSeries_inputGroup__T20pa select {
    padding: 0.875rem;
    border: 1.5px solid #333333;
    border-radius: 8px;
    font-size: 1rem;
    color: #FFFFFF;
    background-color: #1A1A1A;
    transition: all 0.2s ease;
  }
  
  .AddSeries_inputGroup__T20pa input:hover,
  .AddSeries_inputGroup__T20pa textarea:hover,
  .AddSeries_inputGroup__T20pa select:hover {
    border-color: #444444;
    background-color: #222222;
  }
  
  .AddSeries_inputGroup__T20pa input:focus,
  .AddSeries_inputGroup__T20pa textarea:focus,
  .AddSeries_inputGroup__T20pa select:focus {
    outline: none;
    border-color: #D32F2F;
    box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.2);
    background-color: #222222;
  }
  
  .AddSeries_checkboxGroup__ViqA6 {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
  }
  
  .AddSeries_checkboxGroup__ViqA6 label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    color: #FFFFFF;
    font-weight: 500;
  }
  
  .AddSeries_checkboxGroup__ViqA6 input[type="checkbox"] {
    width: 20px;
    height: 20px;
    accent-color: #D32F2F;
    cursor: pointer;
  }
  
  .AddSeries_submitButton__4MDN\\+ {
    background-color: #D32F2F;
    color: white;
    padding: 1rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 1rem;
  }
  
  .AddSeries_submitButton__4MDN\\+:hover {
    background-color: #B71C1C;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3);
  }
  
  .AddSeries_submitButton__4MDN\\+:active {
    transform: translateY(0);
  }

  .AddSeries_sectionTitle__eneRC{
    color: white;
  }
  .AddSeries_tagInput__-5c0G {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
  .AddSeries_addTagButton__Q7\\+lZ {
    padding: 0.75rem 1.5rem;
    background-color: #eb1369;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s;
  }
  
  .AddSeries_addTagButton__Q7\\+lZ:hover {
    background-color: #e21145;
  }
  
  .AddSeries_tagContainer__a1nkZ {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
  
  .AddSeries_tag__BwRU6 {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    background-color: #f0f0f0;
    border-radius: 4px;
    font-size: 0.875rem;
  }
  
  .AddSeries_removeTagButton__smSGW {
    background: none;
    border: none;
    padding: 0.125rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
  }
  
  .AddSeries_removeTagButton__smSGW:hover {
    color: #ff4444;
  }
  
  /* Responsive Styles */
  @media (max-width: 768px) {
    .AddSeries_container__OzAyl {
      padding: 1.5rem;
    }
  
    .AddSeries_form__3BE1y {
      padding: 1.5rem;
    }
  
    .AddSeries_title__yYStD {
      font-size: 1.75rem;
    }
  }
  
  @media (max-width: 480px) {
    .AddSeries_container__OzAyl {
      padding: 1rem;
    }
  
    .AddSeries_form__3BE1y {
      padding: 1.25rem;
      gap: 1.25rem;
    }
  
    .AddSeries_title__yYStD {
      font-size: 1.5rem;
    }
  
    .AddSeries_imageUpload__gRAIr,
    .AddSeries_uploadPlaceholder__ZAp1r,
    .AddSeries_previewContainer__d8HVW {
      min-height: 200px;
      height: 200px;
    }
  
    .AddSeries_inputGroup__T20pa input,
    .AddSeries_inputGroup__T20pa textarea,
    .AddSeries_inputGroup__T20pa select {
      padding: 0.75rem;
    }
  }
  .AddSeries_inputError__trLUG {
    border-color: #ff4444;
  }
  
  .AddSeries_errorMessage__YwhEO {
    color: #ff4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  /* Loading state overlay */
  .AddSeries_loadingOverlay__nIzi- {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .AddSeries_spinner__nPFp8 {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #0066cc;
    border-radius: 50%;
    animation: AddSeries_spin__1vWPk 1s linear infinite;
  }
  
  @keyframes AddSeries_spin__1vWPk {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/Series/AddSeries.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;IAGE,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;;;IAGE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;;IAGE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;IAC5C,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;;MAGE,iBAAiB;MACjB,aAAa;IACf;;IAEA;;;MAGE,gBAAgB;IAClB;EACF;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,mDAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":[".container {\n    min-height: 100vh;\n    padding: 2.5rem;\n    background-color: #000000;\n  }\n  \n  .form {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 2.5rem;\n    background-color: #121212;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(255, 255, 255, 0.05);\n    display: flex;\n    flex-direction: column;\n    gap: 1.75rem;\n  }\n  \n  .title {\n    color: #D32F2F;\n    font-size: 2rem;\n    font-weight: 600;\n    margin-bottom: 1.5rem;\n    position: relative;\n    padding-bottom: 0.75rem;\n  }\n  \n  .title::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 60px;\n    height: 3px;\n    background-color: #D32F2F;\n    border-radius: 3px;\n  }\n  \n  .imageUpload {\n    width: 100%;\n    min-height: 240px;\n    border: 2px dashed #333333;\n    border-radius: 12px;\n    background-color: #1A1A1A;\n    transition: all 0.3s ease;\n  }\n  \n  .imageUpload:hover {\n    border-color: #D32F2F;\n    background-color: #1E1E1E;\n  }\n  \n  .uploadPlaceholder {\n    position: relative;\n    width: 100%;\n    height: 240px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #888888;\n    gap: 1rem;\n  }\n  \n  .uploadPlaceholder::before {\n    content: '📸';\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .fileInput {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n  }\n  \n  .previewContainer {\n    position: relative;\n    width: 100%;\n    height: 240px;\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #1A1A1A;\n  }\n  \n  .preview {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n  }\n  \n  .previewContainer:hover .preview {\n    transform: scale(1.02);\n  }\n  \n  .removeButton {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background-color: #D32F2F;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n  \n  .removeButton:hover {\n    background-color: #B71C1C;\n    transform: scale(1.05);\n  }\n  \n  .inputGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n  \n  .inputGroup label {\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 0.95rem;\n  }\n  \n  .inputGroup input,\n  .inputGroup textarea,\n  .inputGroup select {\n    padding: 0.875rem;\n    border: 1.5px solid #333333;\n    border-radius: 8px;\n    font-size: 1rem;\n    color: #FFFFFF;\n    background-color: #1A1A1A;\n    transition: all 0.2s ease;\n  }\n  \n  .inputGroup input:hover,\n  .inputGroup textarea:hover,\n  .inputGroup select:hover {\n    border-color: #444444;\n    background-color: #222222;\n  }\n  \n  .inputGroup input:focus,\n  .inputGroup textarea:focus,\n  .inputGroup select:focus {\n    outline: none;\n    border-color: #D32F2F;\n    box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.2);\n    background-color: #222222;\n  }\n  \n  .checkboxGroup {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.5rem 0;\n  }\n  \n  .checkboxGroup label {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    cursor: pointer;\n    color: #FFFFFF;\n    font-weight: 500;\n  }\n  \n  .checkboxGroup input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    accent-color: #D32F2F;\n    cursor: pointer;\n  }\n  \n  .submitButton {\n    background-color: #D32F2F;\n    color: white;\n    padding: 1rem 1.5rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: 1rem;\n  }\n  \n  .submitButton:hover {\n    background-color: #B71C1C;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3);\n  }\n  \n  .submitButton:active {\n    transform: translateY(0);\n  }\n\n  .sectionTitle{\n    color: white;\n  }\n  .tagInput {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n  }\n  .addTagButton {\n    padding: 0.75rem 1.5rem;\n    background-color: #eb1369;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.2s;\n  }\n  \n  .addTagButton:hover {\n    background-color: #e21145;\n  }\n  \n  .tagContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n  }\n  \n  .tag {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.25rem 0.5rem;\n    background-color: #f0f0f0;\n    border-radius: 4px;\n    font-size: 0.875rem;\n  }\n  \n  .removeTagButton {\n    background: none;\n    border: none;\n    padding: 0.125rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #666;\n  }\n  \n  .removeTagButton:hover {\n    color: #ff4444;\n  }\n  \n  /* Responsive Styles */\n  @media (max-width: 768px) {\n    .container {\n      padding: 1.5rem;\n    }\n  \n    .form {\n      padding: 1.5rem;\n    }\n  \n    .title {\n      font-size: 1.75rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .container {\n      padding: 1rem;\n    }\n  \n    .form {\n      padding: 1.25rem;\n      gap: 1.25rem;\n    }\n  \n    .title {\n      font-size: 1.5rem;\n    }\n  \n    .imageUpload,\n    .uploadPlaceholder,\n    .previewContainer {\n      min-height: 200px;\n      height: 200px;\n    }\n  \n    .inputGroup input,\n    .inputGroup textarea,\n    .inputGroup select {\n      padding: 0.75rem;\n    }\n  }\n  .inputError {\n    border-color: #ff4444;\n  }\n  \n  .errorMessage {\n    color: #ff4444;\n    font-size: 0.875rem;\n    margin-top: 0.25rem;\n  }\n  \n  /* Loading state overlay */\n  .loadingOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  .spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #0066cc;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddSeries_container__OzAyl`,
	"form": `AddSeries_form__3BE1y`,
	"title": `AddSeries_title__yYStD`,
	"imageUpload": `AddSeries_imageUpload__gRAIr`,
	"uploadPlaceholder": `AddSeries_uploadPlaceholder__ZAp1r`,
	"fileInput": `AddSeries_fileInput__oPgXk`,
	"previewContainer": `AddSeries_previewContainer__d8HVW`,
	"preview": `AddSeries_preview__Ey57H`,
	"removeButton": `AddSeries_removeButton__+nv+y`,
	"inputGroup": `AddSeries_inputGroup__T20pa`,
	"checkboxGroup": `AddSeries_checkboxGroup__ViqA6`,
	"submitButton": `AddSeries_submitButton__4MDN+`,
	"sectionTitle": `AddSeries_sectionTitle__eneRC`,
	"tagInput": `AddSeries_tagInput__-5c0G`,
	"addTagButton": `AddSeries_addTagButton__Q7+lZ`,
	"tagContainer": `AddSeries_tagContainer__a1nkZ`,
	"tag": `AddSeries_tag__BwRU6`,
	"removeTagButton": `AddSeries_removeTagButton__smSGW`,
	"inputError": `AddSeries_inputError__trLUG`,
	"errorMessage": `AddSeries_errorMessage__YwhEO`,
	"loadingOverlay": `AddSeries_loadingOverlay__nIzi-`,
	"spinner": `AddSeries_spinner__nPFp8`,
	"spin": `AddSeries_spin__1vWPk`
};
export default ___CSS_LOADER_EXPORT___;
